<form
  [formGroup]="formGroup"
  [iqForm]="formGroup"
  (ngSubmit)="submit($event)"
  novalidate
  autocomplete="off"
>
  <iq-error-message *ngIf="errorMessage" [errorMessage]="errorMessage">
  </iq-error-message>
  <section
    *ngIf="selectableItems && selectableItems.length > 0"
    class="list-container"
  >
    <div class="line-item" *ngFor="let lineItem of itemsFormArray">
      <span>{{ lineItem.get('name').value }}</span>
      <iq-checkbox-input>
        <input
          type="checkbox"
          class="download-checkbox"
          iqInput
          [formControl]="lineItem.get('selected')"
          (change)="onChecked($event, lineItem)"
        />
      </iq-checkbox-input>
    </div>
  </section>
  <ng-content> </ng-content>
</form>
